export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/v67c52b16d6a0309d2a4c363d2fb1aa5ca4bca8a3-runtime-main.8ca6ea911411cf253f93.worker.js");
}
